import createReactClass from "create-react-class";
import { PropTypes } from "prop-types";

const TRIGGER_OFFSET_RATIO = 0.2;
const UNTRIGGER_OFFSET_RATIO = 0.4;

var ScrollListener = createReactClass({
  propTypes: {
    onScrollEnd: PropTypes.func,
  },

  getInitialState() {
    let scrollEl = this.props.elRef?.current;

    return {
      triggered: false,
      scrollEl,
    };
  },

  handleScroll: function (event) {
    const scrollEl = this.state.scrollEl;
    // console.log(event);
    // Call the passed-in prop
    // if (this.props.onWindowScroll) this.props.onWindowScroll(event);

    const offsetHeight = scrollEl.offsetHeight;
    const scrollTop = scrollEl.scrollTop;
    const toEnd = scrollEl.scrollHeight - scrollTop - offsetHeight;
    const offset = offsetHeight * TRIGGER_OFFSET_RATIO;
    const unTriggerOffset = offsetHeight * UNTRIGGER_OFFSET_RATIO;

    // console.log({
    //   innerHeight: scrollEl.innerHeight,
    //   scrollY: scrollEl.scrollY,
    //   offsetHeight: document.body.offsetHeight,
    //   offset,
    //   scrollEl,
    // });

    // console.log({
    //   offsetHeight: scrollEl.offsetHeight,
    //   scrollTop: scrollEl.scrollTop,
    //   left: scrollEl.scrollHeight - scrollEl.scrollTop - scrollEl.offsetHeight,
    // });

    if (!this.state.triggered && toEnd < offset) {
      console.warn("Scroll End");

      this.setState({ triggered: true });
      // you're at the bottom of the page
      if (this.props.onScrollEnd) this.props.onScrollEnd(event);
    }

    if (this.state.triggered && toEnd > unTriggerOffset) {
      this.setState({ triggered: false });

      console.warn("Scroll End Reset");
    }
  },

  render: function () {
    return this.props.children || null;
  },

  componentDidMount: function () {
    let scrollEl = this.state.scrollEl;
    if (this.props.scrollEl?.current) {
      scrollEl = this.props.scrollEl?.current;
      this.setState({ scrollEl });
    }

    if (!scrollEl && this.props.scrollSelector) {
      let scrollEls = document.querySelectorAll(this.props.scrollSelector);
      scrollEl = scrollEls[scrollEls.length - 1];
      if (scrollEl) {
        this.setState({ scrollEl });
      }
    }

    if (!scrollEl) {
      scrollEl = window;
    }

    if (scrollEl && (this.props.onWindowScroll || this.props.onScrollEnd)) {
      scrollEl.addEventListener("scroll", this.handleScroll);
      // console.warn("Listening scroll: ", this.state.scrollEl, scrollEl);
    }
  },

  componentWillUnmount: function () {
    if (this.state.scrollEl) {
      this.state.scrollEl.removeEventListener("scroll", this.handleScroll);
    }
  },
});

export default ScrollListener;
